import { render, staticRenderFns } from "./orgusercontrol.vue?vue&type=template&id=3157b194"
import script from "./orgusercontrol.vue?vue&type=script&lang=js"
export * from "./orgusercontrol.vue?vue&type=script&lang=js"
import style0 from "./orgusercontrol.vue?vue&type=style&index=0&id=3157b194&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports